import {
  queryBussAllSignRules,
  updateBussSignRule,
  queryUserPhoneIntegralRechargeRecordPage,
  queryUserScoreList
} from '@/api/sys.score'

export default {
  namespaced: true,
  actions: {
    /**
         * 分页查询
         */
    queryBussAllSignRules ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryBussAllSignRules(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    
    updateBussSignRule ({
      dispatch
    }, {
      vm,
      data
    }) {
      return updateBussSignRule(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    
    queryUserPhoneIntegralRechargeRecordPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryUserPhoneIntegralRechargeRecordPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },

    queryUserScoreList ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryUserScoreList(data)
        .then(res => {
          return res.data.data
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
    
  }
}
